import React from 'react';
import './CustomerFilterTabs.css';

const CustomerFilterTabs = ({ activeFilter, onFilterChange }) => {
  const tabs = ['All Customers', 'Top Spenders', 'Regular', 'New', 'Inactive (30+ days)'];

  return (
    <div className="customer-filter-tabs">
      {tabs.map(tab => {
        const isActive = activeFilter === tab || 
          (tab === 'All Customers' && activeFilter === 'All');
        return (
          <button
            key={tab}
            className={`filter-tab ${isActive ? 'active' : ''}`}
            onClick={() => onFilterChange(tab === 'All Customers' ? 'All' : tab)}
          >
            {tab}
          </button>
        );
      })}
    </div>
  );
};

export default CustomerFilterTabs;

